import { Component } from '@angular/core';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import { NavController } from '@ionic/angular';
import { IterableDiffers, DoCheck } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'scoreboard-name',
    templateUrl: 'scoreboard-by-name.html',
    styleUrls:['./scoreboard-by-name.scss']
  })

  export class ScoreBoardName {

    differ: any;
    athletesArray = [];
    routerState:any;

      constructor (private storage: StorageProvider,
        private navCtrl: NavController, private router:Router, differs: IterableDiffers) {
        const nav = this.router.getCurrentNavigation();
        this.routerState = nav?.extras?.state || {};
        this.differ = differs.find([]).create(null);
        this.getArray();
      }

      ngDoCheck() {
        const change = this.differ.diff(this.athletesArray);
        
        this.sortArray();
        console.log("change");
        
      }

      async getArray() {
        this.athletesArray = this.athletesArray.concat(this.routerState['arr']);
        
        console.log("ath arr " + JSON.stringify(this.athletesArray));
      }

      onBackMenu() {
        this.athletesArray.length = 0;
        
        this.navCtrl.pop();
      }

      sortArray(){
        let arr;

        arr = this.athletesArray.sort((a, b) => a.time > b.time && 1 || -1);
        for(let i = 0; i < arr.length; i++){
            arr[i].place = 0;
        }

        for(let i = 0; i < arr.length; i++){
            arr[i].place = i + 1;
        }

        console.log("arr sorted" + JSON.stringify(arr));
        
        this.athletesArray = arr;
      }

      openEditWindow(athlete){
        this.navCtrl.navigateForward('/edit-athlete', {state:{ath:athlete}});
          // this.navCtrl.push(EditAthleteData, {ath: athlete});
          console.log("open edit window");
      }
  }